<template>
  <div class="product-form">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>登録</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="シリアルNo.:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="form.id" plaintext />
          </b-form-group>
          <b-form-group label="ステータス:" label-cols-md="2" label-align-md="right">
            <b-input-group>
              <b-form-input v-model="status_labels[form.status]" disabled />
              <b-input-group-append v-if="form.status === 'draft'">
                <b-button @click="onPublic" variant="primary">公開</b-button>
              </b-input-group-append>
              <b-input-group-append v-if="form.status === 'public'">
                <b-button @click="onStatusChange('finish')" variant="secondary">済</b-button>
                <b-button @click="onStatusChange('cancel')" variant="danger">取消</b-button>
              </b-input-group-append>
              <b-input-group-append v-if="form.status === 'finish'">
                <b-button @click="onStatusChange('public')" variant="primary">再公開</b-button>
                <b-button @click="onStatusChange('cancel')" variant="danger">取消</b-button>
              </b-input-group-append>
              <b-input-group-append v-if="form.status === 'cancel'">
                <b-button @click="onStatusChange('public')" variant="primary">再公開</b-button>
                <b-button @click="onStatusChange('finish')" variant="secondary">済</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label="種別:" label-cols-md="2" label-align-md="right">
            <FormValidatorSelect name="種別" :form="$v.form.type" :options="type_options" />
          </b-form-group>
          <b-form-group label="メーカー名:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="メーカー名" :form="$v.form.maker" />
          </b-form-group>
          <b-form-group label="商品名:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="商品名" :form="$v.form.name" />
          </b-form-group>
          <b-form-group label="CAS No.:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="CAS No." :form="$v.form.cas_no" />
          </b-form-group>
          <b-form-group label="FEMA No.:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="FEMA No." :form="$v.form.fema_no" />
          </b-form-group>
          <b-form-group label="入目:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="入目" :form="$v.form.pieces" append="kg" />
          </b-form-group>
          <b-form-group label="数量:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="数量" :form="$v.form.nums" />
          </b-form-group>
          <b-form-group label="メモ欄:" label-cols-md="2" label-align-md="right">
            <FormValidatorTextarea name="メモ欄" :form="$v.form.synonym" :rows="5" />
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">更新</b-button>
          <b-button type="reset" variant="outline-primary">リセット</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, maxLength, decimal, integer } from 'vuelidate/lib/validators';

export default {
  name: 'ProductForm',

  data() {
    return {
      status_labels: {
        '': '未登録',
        draft: '下書き',
        public: '公開中',
        finish: '済',
        cancel: '取消',
      },
      type_options: [
        { value: 'sell', text: '売りたい' },
        { value: 'buy', text: '買いたい' },
      ],
    };
  },

  computed: {
    ...mapState({
      form: state => state.products.form,
    }),
  },

  validations: {
    form: {
      type: {
        required,
      },
      maker: {
        maxLength: maxLength(255),
      },
      name: {
        required,
        maxLength: maxLength(255),
      },
      cas_no: {
        maxLength: maxLength(255),
      },
      fema_no: {
        maxLength: maxLength(255),
      },
      pieces: {
        decimal,
      },
      nums: {
        decimal,
      },
      synonym: {
        maxLength: maxLength(65536),
      },
    },
  },

  methods: {
    onSubmit(evt) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }

      if (this.form.id) {
        this.$store.dispatch('products/updateItem', {
          form: this.form,
          callback: (data) => {},
        });
      } else {
        this.$store.dispatch('products/addItem', {
          form: this.form,
          callback: (data) => {
            this.$router.push('/product/edit/' + data.id.toString(), () => {}, () => {});
          },
        });
      }
    },

    onReset(evt) {
      this.$v.form.$reset();
      if (this.form.id) {
        this.$store.dispatch('products/loadForm', this.form.id);
      } else {
        this.$store.dispatch('products/clearForm');
      }
    },

    onPublic() {
      if (this.form.id) {
        this.$utils.confirm('製品情報公開', '製品情報を公開します。\n※種別：「買いたい」で、ステータス：「公開中」に更新した際、お知らせのメールが送信されます。', () => {
          this.$store.dispatch('products/changePublic', this.form.id);
        });
      }
    },

    onStatusChange(status) {
      if (this.form.id) {
        this.$store.dispatch('products/statusChange', { id: this.form.id, status: status });
      }
    },
  },
};
</script>

<style scoped>
</style>
